/**
 * Component: Floating Push Notification (custom-floating-notification.js)
 */

(function () {
  'use strict';

  function initFloatingNotification() {
    const notif = document.querySelector('.juli-floating-notification');
    if (!notif) return;

    const thresholdPercent = parseFloat(notif.dataset.scrollPercent || '40') / 100;
    const closeBtn = notif.querySelector('.juli-notif-close');
    let isDismissed = false;
    let isTicking = false;

    function handleScroll() {
      if (isDismissed) return;

      const scrollTop = window.scrollY || window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollProgress = docHeight > 0 ? scrollTop / docHeight : 0;

      if (scrollProgress >= thresholdPercent) {
        if (!notif.classList.contains('is-visible')) {
          notif.classList.add('is-visible');
        }
      } else {
        if (notif.classList.contains('is-visible')) {
          notif.classList.remove('is-visible');
        }
      }
      isTicking = false;
    }

    window.addEventListener('scroll', () => {
      if (!isTicking) {
        window.requestAnimationFrame(handleScroll);
        isTicking = true;
      }
    }, { passive: true });

    // Initial check on load
    handleScroll();

    // Live Real-Time Timestamp Updater (e.g. 1m ago -> 2m ago -> 3m ago...)
    const timeEl = notif.querySelector('.juli-notif-time');
    if (timeEl) {
      const STORAGE_KEY = 'juli_notif_created_at';
      let createdAt = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
      
      // If not yet stored or invalid, initialize timestamp to 60 seconds ago so it starts naturally at "1m ago"
      if (!createdAt || isNaN(createdAt)) {
        createdAt = Date.now() - 60 * 1000;
        try {
          sessionStorage.setItem(STORAGE_KEY, createdAt.toString());
        } catch (e) {}
      }

      function updateLiveTimestamp() {
        const now = Date.now();
        const diffSeconds = Math.max(0, Math.floor((now - createdAt) / 1000));
        
        let label = '1m ago';
        if (diffSeconds < 60) {
          label = 'now';
        } else if (diffSeconds < 3600) {
          const mins = Math.floor(diffSeconds / 60);
          label = `${mins}m ago`;
        } else if (diffSeconds < 86400) {
          const hours = Math.floor(diffSeconds / 3600);
          label = `${hours}h ago`;
        } else {
          const days = Math.floor(diffSeconds / 86400);
          label = `${days}d ago`;
        }
        
        timeEl.textContent = label;
      }

      updateLiveTimestamp();
      setInterval(updateLiveTimestamp, 10000); // Check and tick smoothly every 10 seconds
    }

    // Close button dismiss or collapse
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (notif.classList.contains('is-expanded')) {
          notif.classList.remove('is-expanded');
        } else {
          isDismissed = true;
          notif.classList.remove('is-visible');
          notif.classList.remove('is-expanded');
        }
      });
    }

    // Card click: on mobile, first tap expands card (shows text); second tap opens modal
    notif.addEventListener('click', (e) => {
      if (e.target.closest('.juli-notif-close')) return;
      
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      const modalTarget = notif.dataset.modalTarget || notif.dataset.juliModal || 'contact';
      
      if (isMobile) {
        if (!notif.classList.contains('is-expanded')) {
          // Step 1: Expand and reveal the information card!
          e.preventDefault();
          e.stopPropagation();
          notif.classList.add('is-expanded');
          return;
        }

        // Step 2: User taps while card is already expanded -> open modal!
        if (window.JuliModals) {
          e.preventDefault();
          notif.classList.remove('is-expanded');
          window.JuliModals.openModal(modalTarget);
        }
      } else {
        // Desktop: Open modal directly
        if (window.JuliModals) {
          e.preventDefault();
          window.JuliModals.openModal(modalTarget);
        }
      }
    });

    // Tap outside to collapse on mobile
    document.addEventListener('click', (e) => {
      if (notif.classList.contains('is-expanded')) {
        if (!notif.contains(e.target)) {
          notif.classList.remove('is-expanded');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingNotification);
  } else {
    initFloatingNotification();
  }
})();
